import { connect } from 'react-redux'
import ReferralCodeComponent from '../../components/dashboard/referralCode.component'
import { sendReferral, closeRererralSnackbar } from '../../actions'

/**
 * @author Huong Nguyen
 */

const mapStateToProps = (state) => {
  return {
    state,
    showSnackBar: state.dashboard.showSnackBar,
    showFailSnackBar: state.dashboard.showFailSnackBar,
    emailExist: state.dashboard.emailExist
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    sendReferral: (data) => dispatch(sendReferral(data)),
    closeRererralSnackbar: () => dispatch(closeRererralSnackbar())
  }
}

const ReferralCodeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferralCodeComponent)

export default ReferralCodeContainer
